import jCanvasList from '@/views/canvas/jCanvasList';
import jCanvasDetail from '@/views/canvas/jCanvasDetail';

import auth from '@/middleware/auth';
import log from '@/middleware/log';
import admin from '@/middleware/admin';

export default [
  {
    path: '/canvas',
    name: 'jCanvasList',
    component: jCanvasList,
    meta: {
      title: 'Canvas',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
  {
    path: '/canvas/create',
    name: 'jCanvasDetail',
    component: jCanvasDetail,
    meta: {
      title: 'Canvas',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
  {
    path: '/canvas/update/:canvasId',
    name: 'jCanvasDetail',
    component: jCanvasDetail,
    meta: {
      title: 'Canvas',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/jRouterCanvas.js